import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useLeadsDashboardData } from "../hooks/useLeadsDashboardData";
import DateRangePickerComponent from "../../../../core/common/crmComponents/DateRangePickerComponent";
import {
  getDateRange,
  incrementDateByOne,
} from "../../../../utils/helpers/helper";
import BarChartLoader from "../../../../core/common/crmComponents/loaders/BarChartLoader";
import { Box } from "@mui/material";

const LeadsSourceCountTable = ({ selectedCompany }) => {
  const [dateRange, setDateRange] = useState(getDateRange());

  const { data, isLoading, isError, error } = useLeadsDashboardData({
    groupFields: "leadSource",
    sort: "-createdTime",
    ofCompany: selectedCompany,
    "createdTime[gte]": dateRange.startDate,
    "createdTime[lte]": incrementDateByOne(dateRange.endDate),
  });

  const leads = data?.data?.data || [];

  const totalSourcesCount = leads?.length;
  const allLeadsSourceCount = leads?.reduce((acc, curr) => acc + curr.count, 0);

  // Prepare DataGrid rows
  const rows = leads?.map((lead, index) => ({
    id: index + 1,
    leadSource: lead._id.leadSource || "Unknown Source",
    count: lead.count || 0,
  }));

  const columns = [
    {
      field: "leadSource",
      headerName: "Lead Source",
      width: 250,
      renderCell: (params) => (
        <div>
          <span>{params?.row?.leadSource}</span>
        </div>
      ),
    },
    {
      field: "count",
      headerName: "Count",
      width: 150,
      type: "number",
    },
  ];

  return (
    <div className="col-md-6 d-flex">
      <div className="card flex-fill">
        <div className="card-header border-0 pb-0">
          <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h4>
              <i className="ti ti-grip-vertical me-1" />
              Leads By Source
            </h4>
            <div className="d-flex align-items-center flex-wrap row-gap-2">
              <DateRangePickerComponent
                dateRange={dateRange}
                setDateRange={setDateRange}
                allowSingleDateSelection={true}
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {isLoading ? (
            <BarChartLoader />
          ) : isError ? (
            <p>Error loading data: {error.message}</p>
          ) : totalSourcesCount === 0 ? (
            <p>No data available.</p>
          ) : (
            <>
              <div className="d-md-flex justify-content-between align-items-center mb-1">
                <p className="mb-0">
                  <span className="me-2 fw-bold">Total Sources:</span>
                  {totalSourcesCount}
                </p>
                <p className="mb-0">
                  <span className="me-2 fw-bold">Total Source Count:</span>
                  {allLeadsSourceCount}
                </p>
              </div>

              {/* MUI DataGrid Table */}
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  rows={rows}
                  columns={columns} // Remove filter icon
                  autoHeight
                  hideFooter
                  disableExtendRowFullWidth
                  sx={{
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "#f5f5f5",
                      fontWeight: "bold",
                    },
                    "& .MuiDataGrid-row": {
                      "&:nth-of-type(even)": {
                        backgroundColor: "#f9f9f9",
                      },
                    },
                  }}
                />
              </Box>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsSourceCountTable;
